<template>
    <IconBase viewBox="0 0 69 66" v-bind="$props" width="100%" height="100%">
        <defs>
            <rect id="path-1" x="0" y="0" width="1100" height="567" rx="5"></rect>
            <filter x="-1.6%" y="-2.2%" width="103.2%" height="106.2%" filterUnits="objectBoundingBox" id="filter-2">
                <feOffset dx="0" dy="5" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                <feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix
                    values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.03 0"
                    type="matrix"
                    in="shadowBlurOuter1"
                ></feColorMatrix>
            </filter>
            <rect id="path-3" x="0" y="0" width="182" height="93"></rect>
        </defs>
        <g id="Page-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="VIK-Project-Documents-thumbs" transform="translate(-381.000000, -342.000000)">
                <g id="Group-4" transform="translate(325.000000, 323.000000)">
                    <g id="cardDocument-Copy-9">
                        <g id="image" transform="translate(10.000000, 10.000000)">
                            <mask id="mask-4" fill="white">
                                <use xlink:href="#path-3"></use>
                            </mask>
                            <g id="Rectangle"></g>
                            <path
                                d="M114.12,23.72 L114.12,23.72 C114.087279,23.6480031 114.050555,23.5778935 114.01,23.51 C113.989253,23.4842166 113.965783,23.4607473 113.94,23.44 C113.904731,23.3835435 113.860871,23.332935 113.81,23.29 L113.81,23.29 L99.19,9.39 L99.19,9.39 C99.05847,9.26730243 98.9060754,9.16909259 98.74,9.1 L98.74,9.1 C98.5707663,9.03512964 98.3912364,9.00125606 98.21,9 L74.5,9 C70.3578644,9 67,12.3578644 67,16.5 L67,58.26 C67,62.4021356 70.3578644,65.76 74.5,65.76 L106.74,65.76 C110.882136,65.76 114.240052,62.4021356 114.240052,58.26 L114.240052,24.31 C114.241721,24.1071035 114.20084,23.9061045 114.12,23.72 Z M99.62,14 L108.93,22.81 L99.62,22.81 L99.62,14 Z M106.7,62.76 L74.5,62.76 C72.0170001,62.7545005 70.0054995,60.7429999 70,58.26 L70,16.52 C70.0054995,14.0370001 72.0170001,12.0254995 74.5,12.02 L96.62,12.02 L96.62,24.31 C96.62,25.1384271 97.2915729,25.81 98.12,25.81 L111.24,25.81 L111.24,58.26 C111.234501,60.7429999 109.223,62.7545005 106.74,62.76 L106.7,62.76 Z M104.62,32.22 C104.62,33.0484271 103.948427,33.72 103.12,33.72 L78.15,33.72 C77.3215729,33.72 76.65,33.0484271 76.65,32.22 C76.65,31.3915729 77.3215729,30.72 78.15,30.72 L103.09,30.72 C103.492997,30.7119384 103.88228,30.8664076 104.170107,31.1485907 C104.457934,31.4307738 104.62,31.8169225 104.62,32.22 Z M104.62,41.02 C104.62,41.8484271 103.948427,42.52 103.12,42.52 L78.15,42.52 C77.3215729,42.52 76.65,41.8484271 76.65,41.02 C76.65,40.1915729 77.3215729,39.52 78.15,39.52 L103.09,39.52 C103.492997,39.5119384 103.88228,39.6664076 104.170107,39.9485907 C104.457934,40.2307738 104.62,40.6169225 104.62,41.02 L104.62,41.02 Z M104.62,50.02 C104.62,50.8484271 103.948427,51.52 103.12,51.52 L78.15,51.52 C77.3215729,51.52 76.65,50.8484271 76.65,50.02 C76.65,49.1915729 77.3215729,48.52 78.15,48.52 L103.09,48.52 C103.492997,48.5119384 103.88228,48.6664076 104.170107,48.9485907 C104.457934,49.2307738 104.62,49.6169225 104.62,50.02 L104.62,50.02 Z"
                                id="Shape"
                                fill="#F0F0F0"
                                fill-rule="nonzero"
                                mask="url(#mask-4)"
                            ></path>
                            <g id="Group-3" mask="url(#mask-4)">
                                <g transform="translate(46.000000, 53.000000)">
                                    <rect
                                        id="Rectangle"
                                        :fill="colour"
                                        fill-rule="evenodd"
                                        x="0"
                                        y="0"
                                        width="44"
                                        height="22"
                                        rx="2"
                                    ></rect>
                                    <text
                                        id="DOC"
                                        fill="none"
                                        font-family="Helvetica"
                                        font-size="12"
                                        font-weight="bold"
                                    >
                                        <tspan x="8.66699219" y="15" fill="#FFFFFF">{{ label }}</tspan>
                                    </text>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
                <g id="Group-5" transform="translate(325.000000, 163.000000)">
                    <g id="cardDocument" transform="translate(0.000000, 10.000000)"></g>
                </g>
            </g>
        </g>
    </IconBase>
</template>

<script>
import iconBaseMixin from './IconBase.js';
export default {
    mixins: [iconBaseMixin],
    props: {
        label: String,
        colour: {
            type: String,
            default: '#4B79E5',
        },
    },
};
</script>
